import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectCollections } from "../../redux/shop/shop.selectors";
// import { PetCollection } from "../../redux/shop/shop.types";

import useStyles from "./shop-by-pet-preview.styles";

const ShopByPetPreview = () => {
  const classes = useStyles();

  const collections = useSelector(selectCollections);
  const petCollections = collections.petCollections;

  return (
    <div className={classes.container}>
      <div className={classes.title}>Shop By Pet</div>
      <div className={classes.petContainer}>
        {/* {petCollections.map((petCollection: PetCollection) => (
          <Link
            key={petCollection.id}
            to={`/shop/pet/${petCollection.path}`}
            className={classes.petLink}
          >
            <div className={classes.petImage}>{petCollection.title} image</div>
            <div className={classes.petTitle}>{petCollection.title}</div>
          </Link>
        ))} */}
      </div>
    </div>
  );
};

export default ShopByPetPreview;
